import { useState } from 'react';
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  InputGroup,
  Row,
  Stack,
} from 'react-bootstrap';
import { useLocation } from 'wouter';

import { CONFIG } from './config';

export function HomePage() {
  const [, navigate] = useLocation();

  const [error, setError] = useState<string>();

  return (
    <>
      <Row style={{ textAlign: 'center' }}>
        <Col>
          <h1 className="text-primary mt-3 mb-5">
            Welcome to the {CONFIG.SITE_NAME} DOI Portal
          </h1>
        </Col>
      </Row>

      <Row>
        {CONFIG.landingPage.map(({ title, texts, footer, search }) => (
          <Col xs={12} md={4} key={`col-${title}`}>
            <Card>
              <Card.Header as="h3" style={{ textAlign: 'center' }}>
                {title}
              </Card.Header>
              <Card.Body>
                {texts.map(({ text }, index) => {
                  const Wrapper = text.startsWith('<') ? 'div' : 'p';
                  return (
                    <Wrapper
                      key={text}
                      className={index === texts.length - 1 ? 'mb-1' : ''}
                      dangerouslySetInnerHTML={{ __html: text }}
                    />
                  );
                })}
              </Card.Body>
              {footer && (
                <Card.Footer>
                  <div dangerouslySetInnerHTML={{ __html: footer }} />
                </Card.Footer>
              )}
              {search && (
                <Card.Footer>
                  <Stack gap={2}>
                    <Form
                      onSubmit={(evt) => {
                        evt.preventDefault();
                        const formData = new FormData(evt.currentTarget);

                        const doi = formData.get('doi');
                        if (typeof doi !== 'string') {
                          throw new TypeError('Expected DOI');
                        }

                        if (!doi.startsWith(CONFIG.doi.prefix)) {
                          setError(search.error);
                          return;
                        }

                        navigate(`/${doi}`);
                      }}
                    >
                      <InputGroup>
                        <Form.Control
                          name="doi"
                          type="text"
                          aria-label="Search DOI"
                          placeholder={search.placeHolder}
                        />

                        <Button type="submit" variant="primary">
                          Search
                        </Button>
                      </InputGroup>
                    </Form>

                    {error && <Alert variant="danger">{error}</Alert>}
                  </Stack>
                </Card.Footer>
              )}
            </Card>
          </Col>
        ))}
      </Row>
    </>
  );
}
